(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aw-product-conversion-sections"] && !Shopify.designMode) return;
  try {
    
  (() => {
    let lightbox;

    const hydrateReviewMedia = (root = document) => {
      root.querySelectorAll('[data-aw42-review-widget] img.jdgm-rev__pic-img[data-src]').forEach((image) => {
        const source = image.getAttribute('data-src');
        if (source && !image.getAttribute('src')) {
          image.setAttribute('src', source);
        }
        image.setAttribute('loading', 'lazy');
        image.setAttribute('decoding', 'async');
      });
    };

    const ensureLightbox = () => {
      if (lightbox) {
        return lightbox;
      }

      lightbox = document.createElement('div');
      lightbox.className = 'aw42-review-lightbox';
      lightbox.setAttribute('hidden', '');
      lightbox.innerHTML = '<button class="aw42-review-lightbox__close" type="button" aria-label="Close review image">×</button><img class="aw42-review-lightbox__image" alt="Customer review image">';
      document.body.appendChild(lightbox);

      lightbox.addEventListener('click', (event) => {
        if (event.target === lightbox || event.target.closest('.aw42-review-lightbox__close')) {
          lightbox.setAttribute('hidden', '');
          document.documentElement.classList.remove('aw42-review-lightbox-open');
        }
      });

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && !lightbox.hasAttribute('hidden')) {
          lightbox.setAttribute('hidden', '');
          document.documentElement.classList.remove('aw42-review-lightbox-open');
        }
      });

      return lightbox;
    };

    const positionReviewPagination = (root = document) => {
      root.querySelectorAll('[data-aw42-review-widget] .jdgm-rev-widg').forEach((reviewWidget) => {
        const pagination = reviewWidget.querySelector('.jdgm-paginate');
        const reviewBody = reviewWidget.querySelector('.jdgm-rev-widg__body');
        if (!pagination || !reviewBody) {
          return;
        }

        pagination.setAttribute('aria-label', 'Review pages');
        if (pagination.nextElementSibling !== reviewBody) {
          reviewWidget.insertBefore(pagination, reviewBody);
        }
      });
    };

    const observeReviewWidgets = () => {
      document.querySelectorAll('[data-aw42-review-widget]').forEach((widget) => {
        if (widget.dataset.aw42Observed === 'true') {
          return;
        }

        widget.dataset.aw42Observed = 'true';
        const observer = new MutationObserver(() => {
          hydrateReviewMedia(widget);
          positionReviewPagination(widget);
        });
        observer.observe(widget, { childList: true, subtree: true });
      });
    };

    document.addEventListener('click', (event) => {
      const target = event.target instanceof Element ? event.target : null;
      const link = target ? target.closest('[data-aw42-review-widget] .jdgm-rev__pic-link') : null;
      if (!link) {
        return;
      }

      const source = link.getAttribute('data-mfp-src') || link.getAttribute('href');
      if (!source) {
        return;
      }

      event.preventDefault();
      const viewer = ensureLightbox();
      const image = viewer.querySelector('.aw42-review-lightbox__image');
      image.setAttribute('src', source);
      viewer.removeAttribute('hidden');
      document.documentElement.classList.add('aw42-review-lightbox-open');
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => {
        hydrateReviewMedia();
        positionReviewPagination();
        observeReviewWidgets();
      }, { once: true });
    } else {
      hydrateReviewMedia();
      positionReviewPagination();
      observeReviewWidgets();
    }

    document.addEventListener('shopify:section:load', (event) => {
      hydrateReviewMedia(event.target);
      positionReviewPagination(event.target);
      observeReviewWidgets();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aw-ys16-dual-battery-sections"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const variants = {
      "12ah": {
        variantId: "53301959426342",
        title: "YS16-1 MAX 12Ah - $779",
        meta: "22.05\" seat - 397 lb - Approx. 103 lb",
        batteryChip: "12Ah",
        weightChip: "Approx. 103 lb",
        offerHeadline: "12Ah Standard: $699 with code ENTRY80",
        offerDetail: "Fallback offer: $719 with code FIT60. Offer applies at checkout.",
        includedTitle: "What's included with YS16-1 MAX 12Ah Standard",
        includedItems: [
          "YS16-1 MAX wide-seat power chair",
          "24V 12Ah battery class and charger",
          "Joystick controller, footrests, anti-tip wheels, and setup guide"
        ]
      },
      "20ah": {
        variantId: "53301954314534",
        title: "YS16-1 MAX 20Ah - $859",
        meta: "22.05\" seat - 397 lb - Approx. 114 lb",
        batteryChip: "20Ah",
        weightChip: "Approx. 114 lb",
        offerHeadline: "20Ah Extended: $799 with code MAX60",
        offerDetail: "Fallback offer: $799 with code FIT60. Offer applies at checkout.",
        includedTitle: "What's included with YS16-1 MAX 20Ah Extended",
        includedItems: [
          "YS16-1 MAX wide-seat power chair",
          "24V 20Ah battery class and charger",
          "Joystick controller, footrests, anti-tip wheels, and setup guide"
        ]
      }
    };

    const setText = (name, value) => {
      document.querySelectorAll(`[data-aw-ys16-output='${name}']`).forEach((node) => {
        node.textContent = value;
      });
    };

    const setIncludedItems = (items) => {
      document.querySelectorAll("[data-aw-ys16-output='includedList']").forEach((list) => {
        list.innerHTML = "";
        items.forEach((item) => {
          const li = document.createElement("li");
          li.textContent = item;
          list.appendChild(li);
        });
      });
    };

    const selectBattery = (battery) => {
      const data = variants[battery] || variants["20ah"];
      document.querySelectorAll("[data-aw-ys16-card]").forEach((card) => {
        const selected = card.getAttribute("data-battery") === battery;
        card.classList.toggle("is-selected", selected);
        card.setAttribute("aria-checked", selected ? "true" : "false");
      });
      document.querySelectorAll("[data-aw-ys16-variant-input]").forEach((input) => {
        input.value = data.variantId;
      });
      setText("batteryChip", data.batteryChip);
      setText("weightChip", data.weightChip);
      setText("offerHeadline", data.offerHeadline);
      setText("offerDetail", data.offerDetail);
      setText("stickyTitle", data.title);
      setText("stickyMeta", data.meta);
      setText("includedTitle", data.includedTitle);
      setIncludedItems(data.includedItems);
      document.documentElement.setAttribute("data-aw-ys16-battery", battery);
    };

    document.querySelectorAll("[data-aw-ys16-root]").forEach((root) => {
      const initial = root.getAttribute("data-aw-default-battery") || "20ah";
      root.querySelectorAll("[data-aw-ys16-card]").forEach((card) => {
        card.addEventListener("click", () => selectBattery(card.getAttribute("data-battery")));
      });
      selectBattery(initial);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
